module.exports = __webpack_public_path__ + "static/media/MonumentExtended-Ultrabold.4c16d219.ttf";